import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.pe');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-pe',
template: templateSource || '',
    styles: [``],
})
export class PageKieraPeComponent implements OnInit {
    public list: any[] = [];
    public showAddModal: boolean = false;
    public newPE: any = { name: '', arch: 'amd64' };
    public selectedFiles: any = { kernel: null, initrd: null, rootfs: null };
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public uploadFileName: string = '';

    // Inline editing
    public editingId: number = 0;
    public editForm: any = { name: '', arch: '' };

    // File replacement
    public replacingFile: any = { id: 0, type: '' };

    // Detail view
    public expandedId: number = 0;

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("search");
        if (code === 200) {
            this.list = data.rows || [];
            this.sortList();
        }
        await this.service.render();
    }

    // ===== Inline Edit =====
    public async startEdit(item: any) {
        this.editingId = item.id;
        this.editForm = { name: item.name, arch: item.arch || 'amd64' };
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingId = 0;
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.editForm.name) return;
        const { code } = await wiz.call("update", { id: this.editingId, data: JSON.stringify(this.editForm) });
        if (code === 200) {
            this.editingId = 0;
            await this.load();
        }
    }

    // ===== Expand/Collapse Detail =====
    public async toggleExpand(id: number) {
        this.expandedId = this.expandedId === id ? 0 : id;
        await this.service.render();
    }

    // ===== File Upload =====
    public onFileSelected(event: any, fileType: string) {
        const files = event.target.files;
        if (files && files.length > 0) {
            this.selectedFiles[fileType] = files[0];
        }
    }

    private uploadFile(url: string, formData: FormData, fileName: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.uploadFileName = fileName;
            this.uploadProgress = 0;
            this.service.render();
            const xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                    this.service.render();
                }
            });
            xhr.addEventListener('load', () => resolve());
            xhr.addEventListener('error', () => reject(new Error('Upload failed')));
            xhr.open('POST', url);
            const csrfCookie = document.cookie.split(';')
                .map((value: string) => value.trim())
                .find((value: string) => value.indexOf('KIERA_CSRF=') === 0);
            if (csrfCookie) xhr.setRequestHeader('X-KiERA-CSRF', csrfCookie.substring('KIERA_CSRF='.length));
            xhr.withCredentials = true;
            xhr.send(formData);
        });
    }

    public async addPE() {
        if (!this.newPE.name) return;
        this.uploading = true;
        this.uploadProgress = 0;
        this.uploadFileName = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(this.newPE) });
            if (code !== 200) { this.uploading = false; await this.service.render(); return; }
            const recordId = data.id;

            for (const fileType of ['kernel', 'initrd', 'rootfs']) {
                if (this.selectedFiles[fileType] && recordId) {
                    const formData = new FormData();
                    formData.append('file', this.selectedFiles[fileType]);
                    await this.uploadFile(`/wiz/api/page.kiera.pe/upload_file?id=${recordId}&type=${fileType}`, formData, this.selectedFiles[fileType].name);
                }
            }

            this.showAddModal = false;
            this.newPE = { name: '', arch: 'amd64' };
            this.selectedFiles = { kernel: null, initrd: null, rootfs: null };
            await this.load();
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            this.uploadFileName = '';
            await this.service.render();
        }
    }

    // ===== File Replacement =====
    public async startFileReplace(id: number, fileType: string) {
        this.replacingFile = { id, type: fileType };
        await this.service.render();
    }

    public async cancelFileReplace() {
        this.replacingFile = { id: 0, type: '' };
        await this.service.render();
    }

    public async onReplaceFileSelected(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const file = files[0];
        const { id, type } = this.replacingFile;

        this.uploading = true;
        this.uploadProgress = 0;
        this.uploadFileName = file.name;
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('file', file);
            await this.uploadFile(`/wiz/api/page.kiera.pe/upload_file?id=${id}&type=${type}`, formData, file.name);
            this.replacingFile = { id: 0, type: '' };
            await this.load();
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            this.uploadFileName = '';
            await this.service.render();
        }
    }

    // ===== File Delete =====
    public async deleteFile(id: number, fileType: string) {
        if (!confirm(`Delete ${fileType} file?`)) return;
        const { code } = await wiz.call("delete_file", { id, type: fileType });
        if (code === 200) await this.load();
    }

    // ===== Download =====
    public downloadFile(id: number, fileType: string) {
        window.open(`/wiz/api/page.kiera.pe/download?id=${id}&type=${fileType}`, '_blank');
    }

    // ===== PXE Sync =====
    public async syncPXE(id: number) {
        const { code } = await wiz.call("sync_pxe", { id });
        if (code === 200) {
            await this.load();
        }
    }

    // ===== Migration =====
    public async migrateFiles() {
        const { code, data } = await wiz.call("migrate_files");
        if (code === 200) {
            const count = data.count || 0;
            alert(`Migration complete: ${count} files migrated`);
            await this.load();
        }
    }

    // ===== Delete =====
    public async deleteItem(id: number) {
        if (!confirm("Are you sure you want to delete this PE image?\nThis will also delete all associated files.")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) await this.load();
    }

    // ===== Hash =====
    public async hashRecreate(id: number) {
        const { code, data } = await wiz.call("hash_recreate", { id });
        if (code === 200) {
            const results = data.results || {};
            const msgs = Object.entries(results).map(([k, v]: any) => `${k}: ${v.md5}`);
            if (msgs.length > 0) alert(`MD5 hash recreated:\n${msgs.join('\n')}`);
            else alert('No files found to hash');
            await this.load();
        }
    }

    // ===== Utility =====
    public formatSize(bytes: any): string {
        if (!bytes || bytes === 0) return '';
        const b = Number(bytes);
        const units = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(b) / Math.log(1024));
        return (b / Math.pow(1024, i)).toFixed(1) + ' ' + units[i];
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id' || field.includes('_size')) {
                return (Number(va) - Number(vb)) * dir;
            }
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraPeComponent;
